import { MouseEvent } from "react";
import { Map } from "immutable";
import { useSelector } from "react-redux";
import { Chat as ChatIcon } from "@remo-co/ui-core/src/icons/Chat";
import { useSendMessage } from "modules/chat";
import { selectIsChatEnabled } from "modules/event/selectors";
import { IUserStatus } from "types";
import { IUser } from "modules/app/types";
import { selectAppInBackground } from "modules/appSetting/redux/selectors";
import { IEvent } from "modules/event/types";
import classnames from "classnames";
import { isEventSpeaker } from "modules/event/utils/eventUtils";
import { useI18n } from "i18n";
import useStyles from "./styles";
import SpeakerIcon from "./icons/speakerIcon.svg";

interface Props {
  userStatus?: IUserStatus;
  isItMe: boolean;
  userInSpace: IUser;
  hasMicCamIssues?: boolean;
  event: IEvent;
  loginUser: IUser;
  isAdmin: boolean;
}

const AvatarStatus = (props: Props): JSX.Element => {
  const { t } = useI18n("common");
  const { startDirectMessage } = useSendMessage();
  const classes = useStyles();
  const {
    userStatus = Map() as unknown as IUserStatus,
    userInSpace,
    isItMe,
    hasMicCamIssues,
    event,
    loginUser,
    isAdmin,
  } = props;
  const loginUserId = loginUser.id;
  const isAppInBackground = useSelector(selectAppInBackground);
  const isChatEnabled = useSelector(selectIsChatEnabled);
  const userId = userInSpace.id;
  const isSpeaker = isEventSpeaker(event, userId, userInSpace.email);

  const handleStartChatClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    startDirectMessage(userId, loginUserId);
  };

  const renderIcons = () => {
    if (isAppInBackground) {
      return null;
    }

    if (userStatus.get("isScreenSharing")) {
      return <span className={classes.screenShare} />;
    }

    return null;
  };

  return (
    <>
      {renderIcons()}
      {!isItMe && isChatEnabled && (
        <button
          type="button"
          onClick={handleStartChatClick}
          className={classnames(classes.avChat, {
            [classes.hasIssues]: hasMicCamIssues,
          })}
          title="Send message"
        >
          <ChatIcon />
        </button>
      )}
      {isSpeaker && !isAdmin && (
        <img src={SpeakerIcon} className={classes.speaker} alt={t("speaker")} />
      )}
    </>
  );
};

export default AvatarStatus;
